import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoader24 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
			id: "tybma2jw5a",
			d: "M0 0L10 0 10 16.667 0 16.667z"
		}) }),
		/* @__PURE__ */ _jsx("g", {
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsxs("g", {
				transform: "translate(-159 -2413) translate(0 2102) translate(159 311) translate(2 2)",
				children: [/* @__PURE__ */ _jsx("mask", {
					id: "xdhgkfq07b",
					fill: "#fff",
					children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#tybma2jw5a" })
				}), /* @__PURE__ */ _jsx("path", {
					fill: "#D7DCE0",
					d: "M2.625 15.255c.412-.37 1.045-.334 1.412.078C2.724 13.866 2 11.972 2 10c0-4.411 3.589-8 8-8-.552 0-1-.447-1-1 0-.553.448-1 1-1C4.486 0 0 4.486 0 10c0 2.465.904 4.833 2.547 6.667-.368-.412-.334-1.044.078-1.412",
					mask: "url(#xdhgkfq07b)"
				})]
			}), /* @__PURE__ */ _jsx("path", {
				fill: "#1DC1E1",
				d: "M10 20c-2.841 0-5.558-1.215-7.453-3.333-.368-.412-.334-1.044.078-1.412.412-.369 1.045-.334 1.412.078C5.554 17.028 7.727 18 10 18c4.411 0 8-3.589 8-8s-3.589-8-8-8c-.552 0-1-.447-1-1 0-.553.448-1 1-1 5.514 0 10 4.486 10 10s-4.486 10-10 10",
				transform: "translate(-159 -2413) translate(0 2102) translate(159 311) translate(2 2)"
			})] }) }) }) })
		})
	]
});
const ForwardRef = forwardRef(SvgLoader24);
export default ForwardRef;
